import _ from 'lodash'
import { E_Eigenvalue } from "@/types";
import { E_AlarmType } from '@/api/enums';
import { gVm } from '@/global';

// 单位相关
const EigenvalueUnitMap = {
    [E_Eigenvalue.Acceleration]: '(m/s²)',
    [E_Eigenvalue.VibrationSeverity]: '(mm/s)',
    [E_Eigenvalue.Offset]: '(μm)',
    [E_Eigenvalue.Temperature]: '(℃)',
    [E_Eigenvalue.TemperatureIncrease]: '(℃)',
    [E_Eigenvalue.Kurtosis]: '',
    [E_Eigenvalue.CrestFactor]: '(m/s²)',
    [E_Eigenvalue.EnvelopeDemodulation]: '(m/s²)',
    [E_Eigenvalue.AxialDisplacement]: '(μm)',
    [E_Eigenvalue.RotationalSpeed]: '(r/min)',
    [E_Eigenvalue.Angle]: '(°)',
    [E_Eigenvalue.HighFrequencyAcceleration]: '',
    [E_Eigenvalue.Battery]: '(V)',
    [E_Eigenvalue.Ambienttem]: '(℃)',
    [E_Eigenvalue.Rssi]: '(dBm)',
    [E_Eigenvalue.VFreq]: '(Hz)',
    [E_Eigenvalue.Slope]: '(°)',
    [E_Eigenvalue.Current]: '(A)',

    [E_Eigenvalue.Ex]: '(%LEL)',
    [E_Eigenvalue.H2s]: '(PPM)',
    [E_Eigenvalue.Co]: '(PPM)',
    [E_Eigenvalue.Nh3]: '(PPM)',
    [E_Eigenvalue.So2]: '(PPM)',
    [E_Eigenvalue.Dust]: '(ug/m3)',
    [E_Eigenvalue.SoundIntensity]: '(dB)',
}

const EigenvalueDomainUnitMap = {
    [E_Eigenvalue.VelocityDomain]: { y: '(mm/s)', x: 'ms' },
    [E_Eigenvalue.VelocityFrequencyDomain]: { y: '(mm/s)', x: 'Hz' },
    [E_Eigenvalue.AccelerationFrequencyDomain]: { y: '(m/s²)', x: 'Hz' },
    [E_Eigenvalue.AccelerationTimeDomain]: { y: '(m/s²)', x: 'ms' },
    [E_Eigenvalue.EnvelopeSpectrumTimeDomain]: { y: '(m/s²)', x: 'ms' },
    [E_Eigenvalue.EnvelopeSpectrum]: { y: '(m/s²)', x: 'Hz' },
    [E_Eigenvalue.DisplacementTimeDomain]: { y: '(μm)', x: 'ms' },
    [E_Eigenvalue.DisplacementSpectrum]: { y: '(μm)', x: 'Hz' },
}

/**
 * 获取特征值y单位 
 */
export function getEigenvalueUnit(e: E_Eigenvalue, vm?: Vue) {    
    return _.get(EigenvalueUnitMap, e, '')
}

/**
 * 获取特征值x,y单位 
 */
export function getEigenvalueDomainUnit(e: E_Eigenvalue) {
    return _.get(EigenvalueDomainUnitMap, e, {
        x: '',
        y: ''
    })
}


const alarm2EigenValueTable = {
    [E_AlarmType.Vibration]: E_Eigenvalue.VibrationSeverity,
    [E_AlarmType.Steepness]: E_Eigenvalue.Kurtosis,
    [E_AlarmType.Crest]: E_Eigenvalue.Acceleration,
    [E_AlarmType.Temperature]: E_Eigenvalue.Temperature,
    [E_AlarmType.Voltage]: E_Eigenvalue.Battery,
    // [E_AlarmType.Offline]: E_Eigenvalue.,
    [E_AlarmType.Electricity]: E_Eigenvalue.Current,
    [E_AlarmType.Envelope]: E_Eigenvalue.EnvelopeDemodulation,
    [E_AlarmType.HighFrequencyAcceleration]: E_Eigenvalue.Acceleration,
    [E_AlarmType.Slope]: E_Eigenvalue.Angle,
    [E_AlarmType.DipAngle]: E_Eigenvalue.Angle,
    [E_AlarmType.Dust]: E_Eigenvalue.Dust,
    [E_AlarmType.Ex]: E_Eigenvalue.Ex,
    [E_AlarmType.H2s]: E_Eigenvalue.H2s,
    [E_AlarmType.Co]: E_Eigenvalue.Co,
    [E_AlarmType.Nh3]: E_Eigenvalue.Nh3,
    [E_AlarmType.So2]: E_Eigenvalue.So2,
}

/**
 *  
 */
export function alarmTypeToEigenvalue(alarmType: E_AlarmType) {
    return alarm2EigenValueTable[alarmType]
}

export function withEigenvalueUnit(text: string, e: E_Eigenvalue) {
    const unit = getEigenvalueUnit(e)
    return unit ? `${text} ${unit}` : text
}

export function withEigenvalueFromAlarmUnit(text: string, alarmType: E_AlarmType) {
    const e = alarmTypeToEigenvalue(alarmType)
    const unit = getEigenvalueUnit(e)
    return unit ? `${text} ${unit}` : text
}
export function appendUnitFromAlarmType(alarmType: E_AlarmType, text: string) {
    let eigen = alarm2EigenValueTable[alarmType]
    if (eigen) {
        let unit = getEigenvalueUnit(eigen)
        return `${text}${unit}`
    } else {
        return text
    }
}

